import "jquery";
import * as ko from "knockout";
import { TaskApi } from "../Apis/TaskApi";
import { TaskViewModel } from "../ViewModels/TaskViewModel";
export class TaskHandler {
    taskApi: TaskApi;
    taskViewModel: TaskViewModel;
    $tasks: JQuery;
    constructor() {
        this.taskApi = TaskApi.getInstance();
        this.taskViewModel = new TaskViewModel;
        this.$tasks = $("#taskBox");

        if(this.$tasks[0])
            ko.applyBindings(this.taskViewModel,this.$tasks[0]);
    }

    init() {

        this.taskApi.getTasks().then((res) => {
            this.taskViewModel.loading(false);
            this.taskViewModel.tasks(res);
        });
    }
}